import React from 'react';
import { motion } from 'framer-motion';
import { AlertIcon } from './Icons';
export function PainSection() {
  return <section id="pain" className="relative w-full bg-bg-primary py-20 sm:py-28 overflow-hidden" aria-label="The problem with kibble" data-id="element-256">
      {/* Subtle top gradient */}
      <div className="absolute top-0 left-0 right-0 h-32 pointer-events-none" style={{
      background: 'linear-gradient(to bottom, #0a0f0a, transparent)'
    }} aria-hidden="true" data-id="element-257" />

      <div className="max-w-3xl mx-auto px-5 sm:px-8" data-id="element-258">
        {/* Opening — dramatic, line-by-line */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="mb-16" data-id="element-259">
          <p className="font-serif text-xl sm:text-2xl md:text-3xl text-cream/90 leading-relaxed" data-id="element-260">
            You see it every day.
          </p>
          <p className="font-serif text-xl sm:text-2xl md:text-3xl text-cream/70 leading-relaxed mt-4" data-id="element-261">
            The slightly slower walk.
          </p>
          <p className="font-serif text-xl sm:text-2xl md:text-3xl text-cream/70 leading-relaxed mt-4" data-id="element-262">
            The duller coat.
          </p>
          <p className="font-serif text-xl sm:text-2xl md:text-3xl text-cream/70 leading-relaxed mt-4" data-id="element-263">
            The constant scratching.
          </p>
        </motion.div>

        {/* Paragraph — the brainwashing */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="mb-16" data-id="element-264">
          <p className="font-sans text-base sm:text-lg text-cream-muted leading-relaxed" data-id="element-265">
            We've been brainwashed to believe that a brown bag of processed
            starch is "enough." It's not.
          </p>
        </motion.div>

        {/* Stat callout — cancer */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="relative my-16 py-10 px-6 sm:px-10 border-l-4 border-gold bg-bg-card/50 rounded-r-lg" data-id="element-266">
          <AlertIcon className="w-6 h-6 text-urgency-red-bright mb-4" data-id="element-267" />
          <p className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-gold leading-tight" data-id="element-268">
            1 in 2 dogs will develop cancer.
          </p>
          <p className="font-sans text-base sm:text-lg text-cream-muted mt-3" data-id="element-269">
            In the U.S. today. For large breeds, the odds are even worse.
          </p>
        </motion.div>

        {/* Comparison image */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="my-16 rounded-lg overflow-hidden border border-white/5" data-id="element-270">
          <img src="https://cdn.magicpatterns.com/uploads/1aKYbVsamSDgTJcKWLLE3t/image_3-1.png" alt="Comparison: processed kibble in a dark warehouse versus a bowl of fresh broccoli, sardines, blueberries, and egg yolk in warm sunlight" className="w-full h-auto" data-id="element-271" />
          <div className="flex" data-id="element-272">
            <div className="flex-1 bg-gray-900/80 py-3 px-4 text-center" data-id="element-273">
              <p className="font-sans text-xs sm:text-sm text-cream-muted uppercase tracking-wider" data-id="element-274">
                What they sell you
              </p>
            </div>
            <div className="flex-1 bg-green-deep/40 py-3 px-4 text-center" data-id="element-275">
              <p className="font-sans text-xs sm:text-sm text-gold uppercase tracking-wider" data-id="element-276">
                What your dog needs
              </p>
            </div>
          </div>
        </motion.div>

        {/* Stat callout — senior by 6 */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="relative my-16 py-10 px-6 sm:px-10 border-l-4 border-urgency-red bg-bg-card/50 rounded-r-lg" data-id="element-277">
          <p className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-cream leading-tight" data-id="element-278">
            Most giants are considered{' '}
            <span className="text-urgency-red-bright" data-id="element-279">"senior"</span> by age 6.
          </p>
          <p className="font-sans text-base sm:text-lg text-cream-muted mt-3" data-id="element-280">
            Cane Corsos. Mastiffs. Great Danes. Their clocks are ticking faster
            than you think.
          </p>
        </motion.div>

        {/* Closing — the tragedy */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="text-center mt-16" data-id="element-281">
          <p className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-cream leading-tight" data-id="element-282">
            That is a tragedy.
          </p>
          <p className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-gold mt-3" data-id="element-283">
            And it is avoidable.
          </p>
        </motion.div>
      </div>
    </section>;
}